import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import type { StrapiContext } from '@/interfaces/context';
import { globalMapper } from '@/mappers';
import { loadAbort, queryBuilder } from '@/utils';
import { queryParams } from './queryParams';

export const getGlobalStrapiData = (): UseApiCall<StrapiContext> => {
	const controller = loadAbort();
	const url = queryBuilder(queryParams, '/global');
	return {
		call: strapiInstance.get<StrapiContext>(url, {
			signal: controller.signal,
			transformResponse: [(data: string) => globalMapper(JSON.parse(data).data)],
		}),
		controller,
	};
};
